<template>
<div class="page-content">
    <div class="product-details-list view-switch">
        <div class="tab-content">

            <div class="tab-pane active" id="course">
                <div class="course-list-container">
                    <div class="course-list-header">
                        <h2>課程搜尋結果 <span class="comments">({{total}}個課程)</span></h2>
                    </div>

                    <div class="course-list-intro">
                        <p>
                            以下列表展示符合條件的大專院校課程。你可利用搜尋或篩選功能，迅速找到想查詢的課程。例如，可輸入院校名稱、課程名稱、學習範疇或其他相關資訊。若需要更多詳情，歡迎透過電郵與我們聯絡：cs@goodschool.hk
                        </p>
                    </div>

                    <!-- Search Bar -->
                    <div class="search-bar-wrapper">
                        <div class="search-box">
                            <i class="fas fa-search"></i>
                            <input
                                v-model="searchKeyword"
                                @input="doSearch"
                                type="text"
                                placeholder="搜尋關鍵字...">
                        </div>
                    </div>

                    <div class="table-responsive">
                        <table class="table table-striped table-bordered course-list-table">
                            <colgroup>
                                <col class="col1">
                                <col class="col2">
                                <col class="col3">
                                <col class="col4">
                                <col class="col5">
                                <col class="col6">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th @click="sortBy('programme_name')" class="sortable">
                                        課程名稱
                                        <span class="sort-indicator">
                                            <span class="sort-arrow up" :class="{ 'active': sortColumn === 'programme_name' && sortDirection === 'asc' }">▲</span>
                                            <span class="sort-arrow down" :class="{ 'active': sortColumn === 'programme_name' && sortDirection === 'desc' }">▼</span>
                                        </span>
                                    </th>
                                    <th @click="sortBy('institution')" class="sortable">
                                        院校
                                        <span class="sort-indicator">
                                            <span class="sort-arrow up" :class="{ 'active': sortColumn === 'institution' && sortDirection === 'asc' }">▲</span>
                                            <span class="sort-arrow down" :class="{ 'active': sortColumn === 'institution' && sortDirection === 'desc' }">▼</span>
                                        </span>
                                    </th>
                                    <th @click="sortBy('area_of_study')" class="sortable">
                                        學習範疇
                                        <span class="sort-indicator">
                                            <span class="sort-arrow up" :class="{ 'active': sortColumn === 'area_of_study' && sortDirection === 'asc' }">▲</span>
                                            <span class="sort-arrow down" :class="{ 'active': sortColumn === 'area_of_study' && sortDirection === 'desc' }">▼</span>
                                        </span>
                                    </th>
                                    <th @click="sortBy('mode')" class="sortable">
                                        授課模式
                                        <span class="sort-indicator">
                                            <span class="sort-arrow up" :class="{ 'active': sortColumn === 'mode' && sortDirection === 'asc' }">▲</span>
                                            <span class="sort-arrow down" :class="{ 'active': sortColumn === 'mode' && sortDirection === 'desc' }">▼</span>
                                        </span>
                                    </th>
                                    <th @click="sortBy('programme_duration')" class="sortable">
                                        修業期
                                        <span class="sort-indicator">
                                            <span class="sort-arrow up" :class="{ 'active': sortColumn === 'programme_duration' && sortDirection === 'asc' }">▲</span>
                                            <span class="sort-arrow down" :class="{ 'active': sortColumn === 'programme_duration' && sortDirection === 'desc' }">▼</span>
                                        </span>
                                    </th>
                                    <th>
                                        詳情
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in pagedItems" :key="item.courseid" :class="{ 'row-even': index % 2 === 0, 'row-odd': index % 2 !== 0 }">
                                    <td>
                                        <a :href="`/course/${item.courseid}`" @click="showDetails()">
                                            {{item.programme_name}}
                                        </a>
                                    </td>
                                    <td>{{item.institution}}</td>
                                    <td>{{item.area_of_study}}</td>
                                    <td>{{item.mode}}</td>
                                    <td>{{item.programme_duration}}</td>
                                    <td>
                                        <a :href="`/course/${item.courseid}`" class="btn btn-sm btn-info">查看</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="pagination-wrapper">
                        <nav class="custom-pagination">
                            <ul class="pagination">
                                <li class="page-item" :class="{ 'disabled': currentPage === 1 }">
                                    <a class="page-link" @click="goToPage(1)">«</a>
                                </li>
                                <li class="page-item" :class="{ 'disabled': currentPage === 1 }">
                                    <a class="page-link" @click="goToPage(currentPage - 1)">‹</a>
                                </li>

                                <li class="page-item" v-for="page in visiblePages" :key="page" :class="{ 'active': page === currentPage }">
                                    <a class="page-link" @click="goToPage(page)">{{ page }}</a>
                                </li>

                                <li class="page-item" :class="{ 'disabled': currentPage === totalPages }">
                                    <a class="page-link" @click="goToPage(currentPage + 1)">›</a>
                                </li>
                                <li class="page-item" :class="{ 'disabled': currentPage === totalPages }">
                                    <a class="page-link" @click="goToPage(totalPages)">»</a>
                                </li>
                            </ul>
                        </nav>
                        <div class="pagination-info" v-if="total > 0">
                            顯示第 {{ (currentPage - 1) * perPage + 1 }} 至 {{ Math.min(currentPage * perPage, total) }} 條記錄，共 {{ total }} 條
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</div>
</template>

<script>
import * as mixin from './CourseListViewMixin.vue';
let listView = Vue.extend({
    mixins: [mixin],
    props: {
        currentPage: {
            type: Number,
            default: 1
        },
        perPage: {
            type: Number,
            default: 20
        },
        model: {
            type: Object,
            default: () => ({
                keyword: '',
                institutions: {},
                levels: {},
                modes: {},
                areas: {},
                awards: {},
                financeTypes: {}
            })
        },
        category: {
            type: String,
            default: 'govtbc'
        }
    },
    data() {
        return {
            sortColumn: '',
            sortDirection: 'asc',
            searchKeyword: ''
        };
    },
    computed: {
        totalPages() {
            return Math.ceil(this.total / this.perPage);
        },
        visiblePages() {
            const pages = [];
            const maxVisible = 5;
            let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
            let end = Math.min(this.totalPages, start + maxVisible - 1);

            if (end - start + 1 < maxVisible) {
                start = Math.max(1, end - maxVisible + 1);
            }

            for (let i = start; i <= end; i++) {
                pages.push(i);
            }
            return pages;
        }
    },
    watch: {
        model: {
            handler(newVal) {
                if (newVal && newVal.keyword) {
                    this.searchKeyword = newVal.keyword;
                }
            },
            immediate: true
        }
    },
    methods: {
        sortBy(column) {
            if (this.sortColumn === column) {
                this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
            } else {
                this.sortColumn = column;
                this.sortDirection = 'asc';
            }
            this.$emit('sortFromView', column, this.sortDirection);
        },
        goToPage(page) {
            if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
                this.$emit('pageChange', page);
            }
        },
        doSearch() {
            if (this.model) {
                this.model.keyword = this.searchKeyword;
                this.$emit('filterOnChange', this.model);
            }
        }
    }
});
export default listView;
</script>

<style scoped>
.page-content {
    padding: 20px;
    min-height: 100vh;
}

.course-list-container {
    max-width: 1680px;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 12px;
    padding: 30px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.course-list-header {
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 2px solid #f0f0f0;
}

.course-list-header h2 {
    font-size: 24px;
    font-weight: 600;
    color: #333;
    margin: 0;
}

.course-list-header h2 .comments {
    color: #666;
    font-weight: 400;
    margin-left: 10px;
}

.course-list-intro {
    background-color: #f8f9fa;
    border-left: 4px solid #337ab7;
    padding: 15px 20px;
    margin-bottom: 25px;
    border-radius: 0 8px 8px 0;
}

.course-list-intro p {
    margin: 0;
    color: #555;
    line-height: 1.7;
    font-size: 14px;
}

.course-list-table {
    margin-bottom: 0;
    width: 100%;
    table-layout: fixed;
    border-collapse: separate;
    border-spacing: 0;
}

/* Column widths via colgroup */
.course-list-table .col1 { width: 30%; }
.course-list-table .col2 { width: 20%; }
.course-list-table .col3 { width: 20%; }
.course-list-table .col4 { width: 10%; }
.course-list-table .col5 { width: 10%; }
.course-list-table .col6 { width: 10%; }

/* === Responsive: hide from right to left, 詳情(col6) always visible === */

/* <= 1199px: hide 修業期 (col5) */
@media (max-width: 1199px) {
    .course-list-table .col5 { width: 0; display: none; }
    .course-list-table tbody tr td:nth-child(5),
    .course-list-table thead tr th:nth-child(5) { display: none; }
}

/* <= 991px: hide 授課模式 (col4) + 修業期 (col5) */
@media (max-width: 991px) {
    .course-list-table .col4 { width: 0; display: none; }
    .course-list-table .col5 { width: 0; display: none; }
    .course-list-table tbody tr td:nth-child(4),
    .course-list-table thead tr th:nth-child(4) { display: none; }
    .course-list-table tbody tr td:nth-child(5),
    .course-list-table thead tr th:nth-child(5) { display: none; }
}

/* <= 767px: hide 學習範疇 (col3) + 授課模式 (col4) + 修業期 (col5) */
@media (max-width: 767px) {
    .course-list-table .col3 { width: 0; display: none; }
    .course-list-table .col4 { width: 0; display: none; }
    .course-list-table .col5 { width: 0; display: none; }
    .course-list-table tbody tr td:nth-child(3),
    .course-list-table thead tr th:nth-child(3) { display: none; }
    .course-list-table tbody tr td:nth-child(4),
    .course-list-table thead tr th:nth-child(4) { display: none; }
    .course-list-table tbody tr td:nth-child(5),
    .course-list-table thead tr th:nth-child(5) { display: none; }
}

/* <= 575px: hide 院校 (col2) + 學習範疇 (col3) + 授課模式 (col4) + 修業期 (col5) */
@media (max-width: 575px) {
    .course-list-table .col1 { width: 75%; }
    .course-list-table .col2 { width: 0; display: none; }
    .course-list-table .col3 { width: 0; display: none; }
    .course-list-table .col4 { width: 0; display: none; }
    .course-list-table .col5 { width: 0; display: none; }
    .course-list-table tbody tr td:nth-child(2),
    .course-list-table thead tr th:nth-child(2) { display: none; }
    .course-list-table tbody tr td:nth-child(3),
    .course-list-table thead tr th:nth-child(3) { display: none; }
    .course-list-table tbody tr td:nth-child(4),
    .course-list-table thead tr th:nth-child(4) { display: none; }
    .course-list-table tbody tr td:nth-child(5),
    .course-list-table thead tr th:nth-child(5) { display: none; }
}

.course-list-table thead tr {
    background-color: #f8f9fa;
}

.course-list-table th {
    background-color: #e9ecef;
    font-weight: 600;
    white-space: nowrap;
    text-align: center;
    padding: 14px 10px;
    border-bottom: 2px solid #dee2e6;
    color: #495057;
}

.course-list-table th:first-child {
    text-align: left;
    border-radius: 8px 0 0 0;
}

.course-list-table th:last-child {
    border-radius: 0 8px 0 0;
}

.course-list-table th:nth-child(3) {
    text-align: left;
}

.course-list-table td {
    text-align: center;
    padding: 12px 10px;
    vertical-align: middle;
    border-bottom: 1px solid #eee;
    overflow: hidden;
    text-overflow: ellipsis;
}

.course-list-table td:first-child {
    text-align: left;
}

.course-list-table td:nth-child(3) {
    text-align: left;
}

.course-list-table tbody tr {
    transition: background-color 0.2s ease;
}

.course-list-table tbody tr.row-even {
    background-color: #ffffff;
}

.course-list-table tbody tr.row-odd {
    background-color: #fafbfc;
}

.course-list-table tbody tr:hover {
    background-color: #e8f4fc !important;
}

.course-list-table th.sortable {
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s;
}

.course-list-table th.sortable:hover {
    background-color: #dde2e8;
}

.sort-indicator {
    display: inline-flex;
    flex-direction: column;
    margin-left: 5px;
    font-size: 8px;
    vertical-align: middle;
}

.sort-indicator .sort-arrow {
    line-height: 1;
    color: #999;
    transition: color 0.2s;
}

.sort-indicator .sort-arrow.active {
    color: #337ab7;
}

.course-list-table td a {
    color: #337ab7;
    text-decoration: none;
    transition: color 0.2s;
}

.course-list-table td a:hover {
    color: #23527c;
    text-decoration: underline;
}

.pagination-wrapper {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
}

.custom-pagination {
    display: flex;
    justify-content: center;
}

.custom-pagination .pagination {
    margin: 0;
    display: flex;
    gap: 5px;
    list-style: none;
    padding: 0;
}

.custom-pagination .page-item {
    margin: 0;
}

.custom-pagination .page-link {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 36px;
    height: 36px;
    padding: 0 10px;
    border: 1px solid #ddd;
    border-radius: 6px;
    color: #333;
    text-decoration: none;
    font-size: 14px;
    background-color: #fff;
    transition: all 0.2s ease;
    cursor: pointer;
}

.custom-pagination .page-link:hover {
    background-color: #f0f0f0;
    border-color: #ccc;
}

.custom-pagination .page-item.active .page-link {
    background-color: #337ab7;
    border-color: #337ab7;
    color: #fff !important;
}

.custom-pagination .page-item.disabled .page-link {
    color: #ccc;
    cursor: not-allowed;
    background-color: #f9f9f9;
}

.pagination-info {
    color: #666;
    font-size: 13px;
}


@media (max-width: 575px) {
    .course-list-container {
        padding: 15px;
        border-radius: 8px;
    }

    .course-list-header h2 {
        font-size: 18px;
    }

    .course-list-intro {
        padding: 12px 15px;
    }

    .course-list-intro p {
        font-size: 13px;
    }

    .course-list-table th,
    .course-list-table td {
        padding: 10px 6px;
        font-size: 13px;
    }

    .pagination-info {
        font-size: 12px;
        text-align: center;
    }
}

.search-bar-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 8px;
}

.search-box {
    position: relative;
    flex: 1;
    max-width: 400px;
}

.search-box i {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #999;
}

.search-box input {
    width: 100%;
    padding: 10px 12px 10px 35px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 14px;
    transition: border-color 0.2s;
}

.search-box input:focus {
    outline: none;
    border-color: #337ab7;
}

@media (max-width: 767px) {
    .search-bar-wrapper {
        flex-direction: column;
        align-items: stretch;
    }

    .search-box {
        max-width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/course_new/CourseListView.vue